/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

import Switch from "react-bootstrap-switch";
// reactstrap components
import {
  Button,
  Card,
  CardTitle,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col
} from "reactstrap";

import ReactBSAlert from "react-bootstrap-sweetalert";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  fetchGetUserData, 
  fetchGetNewApiToken, 
  fetchDeleteApiToken, 
  fetchDarkMode,
  fetchGetValidationUserId,
  fetchChangeUserId,
  fetchChangePassword
} from "../../actions/user_actions.js";

class User extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        password: "",
        newPassword: "",
        registerConfirmPassword: "",
        passwordState: "",
        newPasswordState: "",
        registerConfirmPasswordState: "",
        classes: "dropdown",
        darkMode: true,
        alert: null,
        userId: "",
        userIdState: "",
        userId_isValidated: null,
    };
  }

  componentDidMount() {
    const { user_info, user } = this.props;
    // console.log(user_info ? user_info.user_id : null, user)
    this.setState({userId: user_info ? user_info.user_id : ""});
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
    if((this.props.user && 
      this.props.user.api_token && 
      !prevProps.user.api_token) || 
      (this.props.user && 
        this.props.user.api_token && 
        prevProps.user && 
        prevProps.user.api_token && 
        this.props.user.api_token !== prevProps.user.api_token)) {
        this.setState({
          alert: (
            <ReactBSAlert
              style={{ display: "block", marginTop: "-100px", width: "600px" }}
              title="Important!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="success"
              btnSize=""
            >
              <p style={{color: "#000"}}>Your new Api Key is </p>
              <p style={{color: "#000"}}><b>{this.props.user.api_token.api_key}</b></p>
            </ReactBSAlert>
          )
        });
    }

    if((user && prevProps.user && user.userId_validated && !prevProps.user.userId_validated) || 
        user && prevProps.user && user.userId_validated && prevProps.user.userId_validated && user.userId_validated !== prevProps.user.userId_validated) {
          if(user.userId_validated.result === true) {
            this.setState({userId_isValidated: true, userIdState: "has-success"});
          } else {
            this.setState({userId_isValidated: false, userIdState: "has-danger"});
          }
    }

    if((user && prevProps.user && user.userId_changed && !prevProps.user.userId_changed) || 
    user && prevProps.user && user.userId_changed && prevProps.user.userId_changed && user.userId_changed !== prevProps.user.userId_changed) {
      this.setState({
        alert: (
          <ReactBSAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="success"
            btnSize=""
          >
            User Id modified successfully!
          </ReactBSAlert>
        )
      });
    }
    // console.log("Props: ",this.props.user, "PrevProps: ", prevProps.user);
    if((user && prevProps.user && user.password_changed && !prevProps.user.password_changed) || (
      user && prevProps.user && user.password_changed && prevProps.user.password_changed && user.password_changed !== prevProps.user.password_changed
    )) {
      this.setState({
        alert: (
          <ReactBSAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Notification!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="success"
            btnSize=""
          >
            Notification sent. Please check your email!
          </ReactBSAlert>
        )
      });
    }
  }

  handleClick = () => {
    if (this.state.classes === "dropdown") {
      this.setState({ classes: "dropdown show" });
    } else {
      this.setState({ classes: "dropdown" });
    }
  };

  handleActiveMode = (ev) => {
    const { fetchDarkMode } = this.props;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    let obj = {
      idToken: idToken,
      dark_mode: ev
    }
    this.setState({
      darkMode: !this.state.darkMode
    }); 
    // if(!ev.props.value) {
      document.body.classList.toggle("white-content");
    // }
    console.log(ev)
    fetchDarkMode(obj);
  };

  verifyEmail = value => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  verifyUserId = value => {
    this.setState({userId_isValidated: false})
    var emailRex = /^([a-z]+[0-9]*)+(-[a-z]+[0-9]*)*$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  compare = (string1, string2) => {
    if (string1 === string2) {
      return true;
    }
    return false;
  };

  registerClick = () => {
    if (this.state.registerEmailState === "") {
      this.setState({ registerEmailState: "has-danger" });
    }
    if (
      this.state.registerPasswordState === "" ||
      this.state.registerConfirmPasswordState === ""
    ) {
      this.setState({ registerPasswordState: "has-danger" });
      this.setState({ registerConfirmPasswordState: "has-danger" });
    }
  };

  change = (event, stateName, type, stateNameEqualTo, maxValue) => {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "new_password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "equalTo":
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [stateName + "State"]: "has-success" });
          this.setState({ [stateNameEqualTo + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
          this.setState({ [stateNameEqualTo + "State"]: "has-danger" });
        }
        break;
      case "number":
        if (this.verifyNumber(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "max-length":
        if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "url":
        if (this.verifyUrl(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "min-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "max-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value <= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "range":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo &&
          event.target.value <= maxValue
        ) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "userId":
        if (this.verifyUserId(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger"});
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  handleGetNewApiToken () {
    const { fetchGetNewApiToken } = this.props;
    let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    fetchGetNewApiToken(idToken);
  }

  notificationDeleteApiToken = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.handleDeleteApiToken()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          You will not be able to recover this api-key
        </ReactBSAlert>
      )
    });
  }

  handleDeleteApiToken () {
    const { fetchDeleteApiToken } = this.props;
    let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    fetchDeleteApiToken(idToken);
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Deleted!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          btnSize=""
        >
          Your api-key has been deleted.
        </ReactBSAlert>
      )
    });
  }

  hideAlert = () => {
    this.setState({
      alert: null,
      userId_isValidated: null,
      userIdState: ""
    });
  };

  handleValidateUserId = () => {
    const { fetchGetValidationUserId } = this.props;
    const { userId } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let objUserIdValidation = {
      idToken: idToken,
      user_id: userId
    }
    fetchGetValidationUserId(objUserIdValidation);
  };

  handleChangeUserId = () => {
    const { fetchChangeUserId } = this.props;
    const { userId } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let objUserIdValidation = {
      idToken: idToken,
      user_id: userId
    }
    fetchChangeUserId(objUserIdValidation);
  };

  handleChangePassword = () => {
    const { fetchChangePassword, user_info } = this.props;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let objChangePassword = {
      idToken: idToken,
      email: user_info.email
    }
    console.log(objChangePassword)
    fetchChangePassword(objChangePassword);
  }
  
  render() {
    let {
      // register form
      userId,
      userIdState,
      userId_isValidated
    } = this.state;
    const { user_info } = this.props
    return (
      <>
        <div className="content">
          {this.state.alert}
          <Row>
            <Col md="8">
              <Card>
                <CardHeader>
                  <h4 className="title">User Data</h4>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label>Company</label>
                          <Input
                            defaultValue={user_info && user_info.organization ? user_info.organization : ""}
                            disabled
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <label>Email address</label>
                          <Input 
                            placeholder="mike@email.com" 
                            type="email" 
                            defaultValue={user_info && user_info.email ? user_info.email : ""}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup className={`has-label ${userIdState}`}>
                          <label>User Id</label>
                          <Input 
                            placeholder="" 
                            type="text" 
                            defaultValue={user_info && user_info.user_id ? user_info.user_id : ""}
                            // style={{maxWidth: "60%"}}
                            onChange={e =>
                              this.change(e, "userId", "userId", 1)
                            }
                          />
                          {this.state.userIdState === "has-danger" ? (
                            <label className="error">This User Id has not a validate format or is not verified.</label>
                          ) : null}
                          {userId_isValidated ? (
                            <label className="success">User Id validated.</label>
                          ) : null}
                          <div style={{display: "flex"}}>
                            <Button 
                              className="btn-link" 
                              color="info"
                              style={{paddingTop: "0px", fontSize: "12px"}}
                              onClick={this.handleValidateUserId}
                            >
                              Validate
                            </Button>
                            <Button 
                              className="btn-link" 
                              color="primary"
                              style={{paddingTop: "0px", fontSize: "12px"}}
                              disabled={!userId_isValidated || userId_isValidated === false ? true : false}
                              onClick={this.handleChangeUserId}
                            >
                              Change User Id
                            </Button>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pl-md-1" md="6">
                        <Card className="card-plain">
                          <CardHeader>
                            <h4 className="title">Background Color</h4>
                          </CardHeader>
                          <CardBody style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <div className="togglebutton switch-change-color mt-3">
                              <span className="label-switch" style={{marginRight: "10px"}}>LIGHT MODE</span>
                              {/* {console.log("Visuals: ", user_info.visuals)} */}
                              {(user_info && user_info.visuals) || (user_info.visuals !== undefined && user_info.visuals === null) ?
                                <Switch
                                  onChange={(event, value)=> this.handleActiveMode(value)}
                                  defaultValue={(user_info, user_info && user_info.visuals && user_info.visuals.dark_mode) || user_info.visuals === null ? true : false}
                                  onText=""
                                  offText=""
                                /> : 
                                <div/>
                              }
                              <span className="label-switch" style={{marginLeft: "10px"}}>DARK MODE</span>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col className="pl-md-1" md="6">
                      <div className="fixed-plugin">
                        <div className="dropdown">
                        <ul className="dropdown-menu show">
                          <li className="header-title">SIDEBAR BACKGROUND</li>
                          <div className="badge-colors text-center">
                            {/* {console.log(this.props)} */}
                            <span
                              className={
                                this.props.location.state.activeColor === "primary"
                                  ? "badge filter badge-primary active"
                                  : "badge filter badge-primary"
                              }
                              data-color="primary"
                              onClick={() => {
                                this.props.handleActiveClick("primary");
                              }}
                            />
                            <span
                              className={
                                this.props.location.state.activeColor === "blue"
                                  ? "badge filter badge-info active"
                                  : "badge filter badge-info"
                              }
                              data-color="info"
                              onClick={() => {
                                this.props.handleActiveClick("blue");
                              }}
                            />
                            <span
                              className={
                                this.props.location.state.activeColor === "green"
                                  ? "badge filter badge-success active"
                                  : "badge filter badge-success"
                              }
                              data-color="success"
                              onClick={() => {
                                this.props.handleActiveClick("green");
                              }}
                            />
                            <span
                              className={
                                this.props.location.state.activeColor === "orange"
                                  ? "badge filter badge-warning active"
                                  : "badge filter badge-warning"
                              }
                              data-color="warning"
                              onClick={() => {
                                this.props.handleActiveClick("orange");
                              }}
                            />
                            <span
                              className={
                                this.props.location.state.activeColor === "red"
                                  ? "badge filter badge-danger active"
                                  : "badge filter badge-danger"
                              }
                              data-color="danger"
                              onClick={() => {
                                this.props.handleActiveClick("red");
                              }}
                            />
                          </div>
                          {/* <li className="adjustments-line">
                            
                          </li> */}
                        </ul>
                        </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-user" style={{height: "454px"}}>
                <CardBody>
                  <CardText />
                  <div className="author">
                    <div className="block block-one" />
                    <div className="block block-two" />
                    <div className="block block-three" />
                    <div className="block block-four" />
                    {/* {console.log(user_info && user_info.organization ? (user_info.organization.split(" ")) : "")} */}
                    <div
                      alt="..."
                      className="avatar"
                      color="success"
                      style={{fontSize: "50px"}}
                    >{user_info && user_info.organization ? (user_info.organization.split(" ").length > 1 ? user_info.organization.split(" ")[0].charAt(0) + user_info.organization.split(" ")[1].charAt(0) : user_info.organization.split(" ")[0].charAt(0)) : ""}</div>
                    {/* {console.log(user_info && user_info.organization ? (user_info.organization.split(" ")[1].charAt(0)) : "")} */}
                    <h4 className="title">{user_info && user_info.organization ? user_info.organization : ""}</h4>
                    <p className="description">{user_info && user_info.email ? user_info.email : ""}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md='8'>
              <Form id="RegisterValidation">
                <Card style={{height: "200px"}}>
                  <CardHeader>
                    <CardTitle tag="h4">Password Change</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Button color="info" onClick={this.handleChangePassword}>
                      Change Password
                    </Button>
                  </CardBody>
                </Card>
              </Form>
            </Col>
            <Col md="4">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Api Key</CardTitle>
                </CardHeader>
                <CardBody style={{display: "flex"}}>
                  {/* <p style={{display: "flex", justifyContent: "center", alignItems: "center", marginRight: "5px"}}>mongo_id: </p> */}
                  <Input
                    value={user_info && user_info.api_key && user_info.api_key.api_key_help ? user_info.api_key.api_key_help : ""}
                    disabled
                    type="text"
                  />
                  <Button 
                    className="btn-link" 
                    color="info" 
                    style={{marginTop: "0px"}} 
                    disabled={user_info && user_info.api_key && user_info.api_key.api_key_help ? false : true}
                    onClick={this.notificationDeleteApiToken.bind(this)}
                  >
                    <i className="tim-icons icon-trash-simple" style={{fontSize: "20px"}}/>
                  </Button>
                </CardBody>
                <CardFooter className="text-left">
                  {/* {console.log(user_info && user_info.api_key)} */}
                  <Button 
                    color="info" 
                    disabled={user_info && user_info.api_key && user_info.api_key.api_key_help ? true : false} 
                    onClick={this.handleGetNewApiToken.bind(this)}
                  >
                    Generate Api Key
                  </Button>
                </CardFooter>
              </Card>
            </Col>
            {/* <Col md="4">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Background Color</CardTitle>
                </CardHeader>
                <CardBody style={{display: "flex", justifyContent: "center", alignItems: "center"}}>                  
                </CardBody>
              </Card>
            </Col> */}
          </Row>
        </div>
      </>
    );
  }
}

function mapStateToProps({user}){
  const user_info = user && user.user_logged ? user.user_logged : null;
  // const user_api_token = user && user.api_token ? user.api_token : null;
  return{
      user_info,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { 
        fetchGetUserData, 
        fetchGetNewApiToken, 
        fetchDeleteApiToken, 
        fetchDarkMode, 
        fetchGetValidationUserId, 
        fetchChangeUserId, 
        fetchChangePassword 
      }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(User);

/* <Col className="px-md-1" md="3">
                        <FormGroup>
                          <label>Username</label>
                          <Input defaultValue="michael23" type="text" />
                        </FormGroup>
                      </Col> */
/* <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label>First Name</label>
                          <Input defaultValue="Mike" type="text" />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <label>Last Name</label>
                          <Input defaultValue="Andrew" type="text" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label>Address</label>
                          <Input
                            defaultValue="Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09"
                            placeholder="Home Address"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="4">
                        <FormGroup>
                          <label>City</label>
                          <Input defaultValue="Mike" type="text" />
                        </FormGroup>
                      </Col>
                      <Col className="px-md-1" md="4">
                        <FormGroup>
                          <label>Country</label>
                          <Input defaultValue="Andrew" type="text" />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="4">
                        <FormGroup>
                          <label>Postal Code</label>
                          <Input placeholder="ZIP Code" type="number" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <FormGroup>
                          <label>About Me</label>
                          <Input
                            cols="80"
                            defaultValue="Lamborghini Mercy, Your chick she so thirsty, I'm in
                            that two seat Lambo."
                            placeholder="Here can be your description"
                            rows="4"
                            type="textarea"
                          />
                        </FormGroup>
                      </Col>
                    </Row> */
                    /* <div className="card-description">
                    Do not be scared of the truth because we need to restart the
                    human foundation in truth And I love you like Kanye loves
                    Kanye I love Rick Owens’ bed design but the back is...
                  </div> */
                  /* <CardFooter>
                  <div className="button-container">
                    <Button className="btn-icon btn-round" color="facebook">
                      <i className="fab fa-facebook" />
                    </Button>
                    <Button className="btn-icon btn-round" color="twitter">
                      <i className="fab fa-twitter" />
                    </Button>
                    <Button className="btn-icon btn-round" color="google">
                      <i className="fab fa-google-plus" />
                    </Button>
                  </div>
                </CardFooter> */
                /* <FormGroup className={`has-label ${passwordState}`}>
                      <label>Password *</label>
                      <Input
                        name="password"
                        type="password"
                        onChange={e => this.change(e, "password", "password")}
                      />
                      {this.state.registerEmailState === "has-danger" ? (
                        <label className="error">
                          Please enter a valid password.
                        </label>
                      ) : null}
                    </FormGroup> */
                    /* <FormGroup className={`has-label ${newPasswordState}`}>
                      <label>New Password *</label>
                      <Input
                        id="newPassword"
                        name="new_password"
                        type="password"
                        autoComplete="off"
                        onChange={e => this.change(e, "registerPassword", "password")}
                      />
                      {this.state.registerPasswordState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                      ) : null}
                    </FormGroup>
                    <FormGroup
                      className={`has-label ${registerConfirmPasswordState}`}
                    >
                      <label>Confirm New Password *</label>
                      <Input
                        equalto="#registerPassword"
                        id="registerPasswordConfirmation"
                        name="password_confirmation"
                        type="password"
                        autoComplete="off"
                        onChange={e =>
                          this.change(
                            e,
                            "registerConfirmPassword",
                            "equalTo",
                            "registerPassword"
                          )
                        }
                      />
                      {this.state.registerConfirmPasswordState ===
                      "has-danger" ? (
                        <label className="error">This field is required.</label>
                      ) : null}
                    </FormGroup>
                    <div className="category form-category">
                      * Required fields
                    </div> */
                    /* <CardFooter className="text-left">
                    <FormGroup check className="pull-left">
                      <Label check>
                        <Input name="optionCheckboxes" type="checkbox" />
                        <span className="form-check-sign" />
                        Accept the terms and conditions
                      </Label>
                    </FormGroup>
                  </CardFooter> */
                  /* <div className={this.state.classes}>
                <a
                  href="#pablo"
                  onClick={e => {
                    e.preventDefault();
                    this.handleClick();
                  }}
                >
                  <i className="fa fa-cog fa-2x" />
                </a>
                
              </div> */